import { render, staticRenderFns } from "./EventRow.vue?vue&type=template&id=ff66775c&scoped=true&"
import script from "./EventRow.vue?vue&type=script&lang=js&"
export * from "./EventRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=ff66775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff66775c",
  null
  
)

export default component.exports